import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

export const Wrapper = ({ children }) => <div>{children}</div>

export const Content = () => {
  const { t } = useTranslation(['buttons', 'noAccessContentPage'])

  return (
    <div className={styles['page-no-access-block']}>
      <div className={styles['no-access-block']}>
        <i className="fa fa-times" aria-hidden="true" />
      </div>
      <h1>{t('noAccessContentPage:accessDeniedTitle')}</h1>
      <p>{t('noAccessContentPage:toVievThis')}</p>
    </div>
  )
}
